<div class="button-spinner" [class]="{ active: isSubmitting }">
	<ea-icon name="working" class="working" [hasMargin]="false"></ea-icon>
</div>
